import { render, staticRenderFns } from "./carer-form.vue?vue&type=template&id=261611c6&scoped=true"
import script from "./carer-form.vue?vue&type=script&lang=js"
export * from "./carer-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261611c6",
  null
  
)

export default component.exports